var _circle, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#D1EAFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2856_22487",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 9,
    width: 12,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 12.6667C14 11.5621 14.8954 10.6667 16 10.6667C17.1046 10.6667 18 11.5621 18 12.6667C18 13.7712 17.1046 14.6667 16 14.6667C14.8954 14.6667 14 13.7712 14 12.6667ZM16 9.33334C14.1591 9.33334 12.6667 10.8257 12.6667 12.6667C12.6667 14.5076 14.1591 16 16 16C17.8409 16 19.3333 14.5076 19.3333 12.6667C19.3333 10.8257 17.8409 9.33334 16 9.33334ZM16 22C14.9911 22 13.4588 21.6737 11.3355 20.9712C11.3702 20.2243 11.8116 19.5122 12.6203 18.9545C13.4639 18.3727 14.6609 18 16 18C17.3391 18 18.5361 18.3727 19.3797 18.9545C20.1882 19.512 20.6296 20.2239 20.6644 20.9707L20.5023 21.0245L20.5008 21.025C18.4599 21.6912 16.981 22 16 22ZM16 16.6667C14.4284 16.6667 12.9587 17.1015 11.8634 17.8568C10.7675 18.6125 10 19.73 10 21.0667V21.2108C10 21.6413 10.2754 22.0234 10.6838 22.1595L10.8205 22.2051C13.0153 22.9367 14.7493 23.3333 16 23.3333C17.202 23.3333 18.848 22.9672 20.9161 22.292L21.315 22.1596C21.724 22.0238 22 21.6414 22 21.2105V21.0667C22 19.73 21.2325 18.6125 20.1367 17.8568C19.0413 17.1015 17.5716 16.6667 16 16.6667Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2856_22487)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 16,
    height: 16,
    fill: "#00206E"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.3e81d90879aafed6c4caf2540516d8fc.svg";
export { ForwardRef as ReactComponent };